import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  EmailSentNotificationModalContainer, type EmailSentNotificationModalProps,
} from './emailSentNotificationModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    EmailNotification: EmailSentNotificationModalProps;
  }
}
modalRenderer.register('EmailNotification', EmailSentNotificationModalContainer);
